<template>
  <div class="tab-bar">
    <div v-for="item in menuList" :key="item.path" class="tab-item" :class="{ active: currentPath === item.path }"
      @click="handleTabClick(item.path)">
      <img :src="item.meta.selectIcon" class="w-52px h-52px" v-if="currentPath == item.path" />
      <img :src="item.meta.icon" class="w-52px h-52px" v-else />
      <span class="mt-12px text-24px PingFangSC font-400" :class="[currentPath == item.path ? 'text-#4B483F' : 'text-#022C1E']">
        {{
          item.meta.title
        }}
      </span>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
// import MenuIcon from './menuIcon.vue'
const modulesFiles = import.meta.glob('../assets/tabbar/*.png', { eager: true })

const iconMap = Object.entries(modulesFiles).reduce((modules, [modulePath, value]) => {
  const name = modulePath.replace(/^.*\/([^/]+)\.[^.]+$/, '$1')
  modules[name] = value.default
  return modules
}, {})

const router = useRouter()
const route = useRoute()

// 從路由配置中獲取菜單列表（只顯示有icon的菜單項）
const menuList = computed(() => {
  const list = router.getRoutes().filter(item => {
    if (item.meta?.isMeun && item.meta?.icon) {
      item.meta.icon = iconMap[item.meta.icon]
      item.meta.selectIcon = iconMap[item.meta.selectIcon]
      return item
    }
  })
  console.log('menuList', list)
  return list
})

// 當前路徑
const currentPath = computed(() => route.path)

// 處理標籤點擊
const handleTabClick = (path) => {
  if (currentPath.value !== path) {
    router.push(path)
  }
}
</script>

<style lang="scss" scoped>
.tab-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  // height: 50px;
  background: #F9F7EB;
  display: flex;
  align-items: center;
  justify-content: space-around;
  border-top:1px solid #A0A0A0;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
  z-index: 999;
  padding-top: 20px;
  padding-bottom: calc(constant(safe-area-inset-bottom) + 20px);
  padding-bottom: calc(env(safe-area-inset-bottom) + 20px);

  .tab-item {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    cursor: pointer;
    user-select: none;
    transition: all 0.3s ease;

    .tab-label {
      font-size: 10px;
      color: #8E8E93;
      transition: color 0.3s ease;
      white-space: nowrap;
    }

    &.active {
      .tab-label {
        color: #007AFF;
        font-weight: 500;
      }
    }

    &:active {
      opacity: 0.6;
    }
  }
}

// 深色主題
@media (prefers-color-scheme: dark) {
  .tab-bar {
    background: #1C1C1E;
    box-shadow: 0 -2px 10px rgba(255, 255, 255, 0.05);

    .tab-item {
      .tab-label {
        color: #98989D;
      }

      &.active {
        .tab-label {
          color: #0A84FF;
        }
      }
    }
  }
}
</style>
